import { GlobalConfig, API } from '@sohohouse/platform-client'

GlobalConfig.dh.set('apiUrl', process.env.API_URL)

export const logError = err => (process.env.NODE_ENV !== 'test') && console.error(err)

export default ({ store, app }, inject) => {
  const { currentUser } = store.getters
  const user = {
    ...(currentUser ? currentUser.account : {}),
    token: store.state.oauth.accessToken
  }

  GlobalConfig.dh.set('shared.apiUrl', app.$env.SH_API_URL)
  GlobalConfig.dh.set('events.eventsLocations', app.$env.EVENTS_LOCATIONS)

  const api = new API({ user })

  api.dh.payments.forms.client.setHeader('Accept', 'application/vnd.api-v2+json')
  // Allow the user and token to come from store getters (observable)
  api.dh.user = { token: store.state.oauth.accessToken }
  api.dh.setToken(store.state.oauth.accessToken)

  inject('api', api.dh)
  inject('logError', logError)
}
